module.exports = __webpack_public_path__ + "static/media/CastConnex.85814ea5.png";